import { __rest, __assign } from 'tslib';
import { useTheme, CircularProgress, Button as Button$1 } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';
import { useButtonStyles } from './ButtonStyles.js';

var Button = function (props) {
    props.textTransform; var loading = props.loading, classesOverride = props.classes, className = props.className, ButtonRef = props.ButtonRef, muiProps = __rest(props, ["textTransform", "loading", "classes", "className", "ButtonRef"]);
    props.classes; var styleProps = __rest(props, ["classes"]);
    var classes = useButtonStyles(styleProps);
    var typography = useTheme().typography;
    var loadingIndicator = {
        startIcon: React.createElement(CircularProgress, { color: "inherit", size: typography.button.fontSize }),
        disabled: true,
    };
    return (React.createElement(Button$1, __assign({ ref: ButtonRef, classes: __assign(__assign({}, classes), classesOverride), className: classNames([className, 'pm-button']) }, muiProps, (loading && loadingIndicator))));
};
Button.displayName = 'Button';

export { Button };
//# sourceMappingURL=Button.js.map
